import React from 'react'

const Col = ({ children, xs, sm, md, lg, xl, offsetXs, offsetSm, offsetMd, offsetLg, offsetXl, className, order }) => {
    const baseClasses = 'relative inline-block px-4' // Tailwind's padding classes

    // Generate responsive width classes
    const widthClasses = `${xs ? `w-${xs}/12` : ''}
                        ${sm ? `sm:w-${sm}/12` : ''}
                        ${md ? `md:w-${md}/12` : ''}
                        ${lg ? `lg:w-${lg}/12` : ''}
                        ${xl ? `xl:w-${xl}/12` : ''}`

    // Generate responsive offset classes
    const offsetClasses = `${offsetXs ? `ml-${offsetXs}/12` : ''}
                         ${offsetSm ? `sm:ml-${offsetSm}/12` : ''}
                         ${offsetMd ? `md:ml-${offsetMd}/12` : ''}
                         ${offsetLg ? `lg:ml-${offsetLg}/12` : ''}
                         ${offsetXl ? `xl:ml-${offsetXl}/12` : ''}`

    // Generate order classes
    const orderClasses = `${order ? `order-${order}` : ''}`

    const allClasses = `${baseClasses} ${widthClasses} ${offsetClasses} ${orderClasses} ${className || ''}`

    return <div className={allClasses.trim()}>{children}</div>
}

export default Col
